import React from 'react';

type Props = {
    defaultMessage: any,            // default message that is shown when no option is selected text or divs
    // showIcon: boolean,
    // noBorder: boolean,

    onCustomize?: any,

    className?   : string
}

export default class PopoverHelpHint extends React.Component<Props, any> {

    // static propTypes = {
    //     defaultMessage: PropTypes.any,            // default message that is shown when no option is selected text or divs
    //     showIcon: PropTypes.bool,
    //     noBorder: PropTypes.bool,
    //
    //     onCustomize: PropTypes.func
    // };

    constructor(props:Props) {
        super(props);

        this.state = {
            message: this.props.defaultMessage
        }
    }

    setMessage = (message:any) => {
        this.setState({
            message: message ? message : this.props.defaultMessage
        });
    }

    render() {
        const classes = Classes('help', this.props.className);

        return (
            <div className={classes}>
                {this.state.message && <span>{this.state.message}</span>}
            </div>
        );

    }
}